/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {submitSetPaycheckMultiAllocation} from '../api'

export const useMutationSubmitSetPaycheckMultiAllocation = createReactQueryMutationHook('submitSetPaycheckMultiAllocation', submitSetPaycheckMultiAllocation)
